/**
 * Legördülő mezők közös szabályai.
 *
 * A törzsadat-listák hossza nagyon eltérő: a nemből három van, nyelvből 184,
 * országból 245, közterület-jellegből nyelvenként közel kétszáz. Ugyanaz a
 * beviteli mód nem jó mindkettőre, ezért a döntés — hány elem fölött legyen
 * kereső — EGY helyen él, itt.
 */

/**
 * Ennyi elem FÖLÖTT kap a mező keresőt; alatta marad a natív legördülő.
 * A natív legördülő rövid listán gyorsabb (egy kattintás, billentyűvel is
 * végigfutható), hosszún viszont a képernyőnél is hosszabb listát nyit.
 */
export const SEARCHABLE_OPTION_THRESHOLD = 10;

// A magyar sor kódja a nyelveknél 'hu', az országoknál 'HU' (short_code) és 'HUN' (code).
const HUNGARIAN_CODES = ['hu', 'hun'];

function isHungarian(option) {
    return HUNGARIAN_CODES.includes(String(option?.code ?? '').toLowerCase())
        || HUNGARIAN_CODES.includes(String(option?.short_code ?? '').toLowerCase());
}

/**
 * A magyar sort a lista élére emeli, a többiek sorrendjét érintetlenül hagyva.
 *
 * A pácienseink túlnyomó része magyar, tehát a leggyakoribb választás az, amiért
 * ma a legtöbbet kell görgetni vagy gépelni. Ha nincs magyar sor a listában (más
 * törzsadat, szűrt lista), a lista változatlanul jön vissza.
 */
export function hungarianFirst(options = []) {
    const hungarian = options.filter(isHungarian);

    return hungarian.length
        ? [...hungarian, ...options.filter((option) => !isHungarian(option))]
        : options;
}
